$(document).ready(function() {
  if ($('.models-landing-page').length > 0) {

    function stickyJoinUs() {
      let stickyElement = document.querySelector('.sticky');
      if (!stickyElement) {
        return;
      }

     let currentStickyPosition = stickyElement.getBoundingClientRect().top + window.pageYOffset;

      window.onscroll = function() {
        if (window.pageYOffset > currentStickyPosition) {
          stickyElement.style.position = "fixed";
          stickyElement.style.top = "0px";
        } else {
          stickyElement.style.position = "relative";
          stickyElement.style.top = "initial";
        }
      }
    }

    function whatYouGetAnimation() {
      $('.container-one, .container-two, .container-three, .container-four, .success-story-column, .step-one, .step-two, .step-three').each(function() {
        if (isInViewport($(this))) {
          $(this).addClass('in-view');
        }
      });
    }

    function isInViewport(element) {
      const rect = element[0].getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    function onScrollWhatYouGet() {
      $(window).on('scroll', function() {
        whatYouGetAnimation();
      });
    }

    stickyJoinUs();
    whatYouGetAnimation();
    onScrollWhatYouGet();
  }
});
